import { elements } from '@ecosystem/newron-design-system';
import classNames from 'classnames';
import React from 'react';
import { ContextManager } from '../../context/manager';
import { useMobile } from '../../context/mobile/mobile.provider';
import { MenuItemWithContext } from '../../types';

const { Icon } = elements;

type MenuContextButtonProps = {
  item: MenuItemWithContext;
  isLoading?: boolean;
  inactive?: boolean;
};
function MenuContextButton({ item, isLoading, inactive }: Readonly<MenuContextButtonProps>) {
  const { label, contextSetting, isDisabled } = item;
  const { isMobile } = useMobile();

  const isButtonDisabled = isDisabled || isLoading;

  const handleClick = () => {
    ContextManager.getInstance().setSettingAsRequiresEdit(contextSetting);
  };

  const baseClassNames = `menu-context-button relative rounded text-left ${
    isMobile ? 'text-md' : 'text-lg'
  } p-0 flex items-center transition-colors`;
  const enabledClassNames = 'text-brand hover:bg-brand-lightest hover:text-brand-dark';
  const disabledClassNames = 'text-inactive cursor-not-allowed';

  const className = `${baseClassNames} ${isButtonDisabled ? disabledClassNames : enabledClassNames}`;

  const iconColor = isButtonDisabled ? 'inactive' : 'brand';

  if (inactive) {
    return (
      <div className={`${baseClassNames} text-brand`}>
        <span className="flex-grow nowrap">{label}</span>
      </div>
    );
  }
  const ChevronDownIcon = Icon.icons['ChevronDown'];
  return (
    <button disabled={isButtonDisabled} onClick={handleClick} style={{ boxShadow: 'none' }} className={className}>
      <span className={classNames('flex-grow ', { nowrap: !isMobile })}>{label}</span>
      <Icon testId="icon-chevron-down" color={iconColor} size="sm">
        <ChevronDownIcon />
      </Icon>
    </button>
  );
}

export { MenuContextButton, MenuContextButtonProps };
